import {
  TREQUEST_ATTACHMENT_APPROVAL_LIST,
  TREQUEST_ATTACHMENT_LIST,
  TRESPONSE_ATTACHMENT_APPROVAL_LIST,
  TRESPONSE_ATTACHMENT_LIST,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

import { Action } from '@ngrx/store';
import { TAttachmentActionTypes } from './attachment.model';

export class FetchAttachmentList implements Action {
  readonly type = TAttachmentActionTypes.FetchAttachmentList;
  constructor(public payload: TREQUEST_ATTACHMENT_LIST) {}
}
export class FetchAttachmentListSuccess implements Action {
  readonly type = TAttachmentActionTypes.FetchAttachmentListSuccess;
  constructor(public payload: TRESPONSE_ATTACHMENT_LIST) {}
}
export class FetchAttachmentListFailure implements Action {
  readonly type = TAttachmentActionTypes.FetchAttachmentListFailure;
  constructor() {}
}

export class FetchAttachmentApprovalList implements Action {
  readonly type = TAttachmentActionTypes.FetchAttachmentApprovalList;
  constructor(public payload: TREQUEST_ATTACHMENT_APPROVAL_LIST) {}
}
export class FetchAttachmentApprovalListSuccess implements Action {
  readonly type = TAttachmentActionTypes.FetchAttachmentApprovalListSuccess;
  constructor(public payload: TRESPONSE_ATTACHMENT_APPROVAL_LIST) {}
}
export class FetchAttachmentApprovalListFailure implements Action {
  readonly type = TAttachmentActionTypes.FetchAttachmentApprovalListFailure;
  constructor() {}
}

export class SetAttachmentListingPaginationOption implements Action {
  readonly type = TAttachmentActionTypes.SetAttachmentListingPaginationOption;
  constructor(public payload: TUserPaginationOption) {}
}

export class SetAttachmentListingSearchStr implements Action {
  readonly type = TAttachmentActionTypes.SetAttachmentListingSearchStr;
  constructor(public payload: string) {}
}

export type TAttachmentActions =
  | FetchAttachmentList
  | FetchAttachmentListSuccess
  | FetchAttachmentListFailure
  | FetchAttachmentApprovalList
  | FetchAttachmentApprovalListSuccess
  | FetchAttachmentApprovalListFailure
  | SetAttachmentListingPaginationOption
  | SetAttachmentListingSearchStr;
